import React from "react";
import ReactDOM from "react-dom";
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    padding: 35,
    fontFamily: 'Roboto',
    color: '#fff'
  },
  heading: {
    fontSize: '2.4rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.7rem',
    },
  },
  subHeading: {
    fontSize: '1.4rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1.2rem',
    },
  }
});

class AppLeftPortal extends React.Component {
  constructor(props) {
    super(props);

    this.rootSelector = document.getElementById("background");
    this.container = document.createElement("div");
  }

  componentDidMount() {
    this.rootSelector.appendChild(this.container);
  }

  componentWillUnmount() {
    this.rootSelector.removeChild(this.container);
  }

  render() {
    const { classes } = this.props;
    const component = (
      <div className={classes.container}>
        <div className={classes.heading}>Bienvenido a <strong>CosmoCare</strong></div>
        {/*<div className={classes.subHeading}>Estudios &amp; análisis de productos <br />cosméticos</div>*/}
      </div>
    );
    return ReactDOM.createPortal(component, this.container);
  }
}

export default withStyles(styles)(AppLeftPortal);


// WEBPACK FOOTER //
// ./src/modules/shared/components/AppLeftPortal.js